var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackingSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.272,
    height: 27.273,
    viewBox: "0 0 27.272 27.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Layer 77",
    d: "M23.727 19.181a4.546 4.546 0 0 0-4.455 3.637H6.454a3.636 3.636 0 1 1 0-7.273h16.364a5.454 5.454 0 1 0 0-10.909H10a4.545 4.545 0 1 0 0 1.818h12.818a3.636 3.636 0 1 1 0 7.273H6.454a5.454 5.454 0 1 0 0 10.909h12.818a4.545 4.545 0 1 0 4.454-5.454zM5.545 8.273a2.727 2.727 0 1 1 2.728-2.728 2.727 2.727 0 0 1-2.728 2.728zm18.182 18.181a2.727 2.727 0 1 1 2.727-2.727 2.727 2.727 0 0 1-2.727 2.727z",
    transform: "translate(-1 -1)",
    style: {
      fill: "currentColor"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingSheet);
export default __webpack_public_path__ + "static/media/tracking_sheet.f1d87ea1ff8bdb00a95f7f256e68f1ca.svg";
export { ForwardRef as ReactComponent };